<template>
    <div id="setup-tab-evo-container">
        <b-row>
            <b-col md="8" lg="8" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.Code')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'api_code'"
                    v-bind:MaxLengthProp="24"
                    v-model="editableItem.apiCode"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_apiCode'"
                    v-on:change="emitChanged"
                >
                </MdEdit>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="8" lg="8" sm="12">
                <MdEdit
                    v-bind:Label="$t('PPDbSetup.Key')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'api_key'"
                    v-bind:MaxLengthProp="32"
                    v-model="editableItem.apiKey"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_apiKey'"
                    v-on:change="emitChanged"
                >
                </MdEdit>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="8" lg="8" sm="12">
                <MdEdit
                    v-bind:Label="$t('insuranceSetup.Url')"
                    v-bind:TypeProp="'text'"
                    v-bind:Name="'api_key'"
                    v-bind:MaxLengthProp="255"
                    v-model="editableItem.apiUrl"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Id="'input_apiUrl'"
                    v-on:change="emitChanged"
                >
                </MdEdit>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'TabSetupEvo',
    props: {
        value: {
            Type: Object,
            default: null
        },
        isReadOnly: {
            Type: Boolean,
            default: false
        }
    },
    data() {
        const defaultItemData = {
            apiCode: '',
            apiKey: '',
            apiUrl: ''
        };
        return {
            editableItem: this.value || defaultItemData,
            defaultItemData: defaultItemData
        };
    },
    watch: {
        value(newVal) {
            this.editableItem = newVal || this.defaultItemData;
        }
    },
    methods: {
        emitChanged() {
            this.$emit('input', this.editableItem);
        }
    }
};
</script>
